import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatSelectChange } from '@angular/material/select';
import { ApiService } from '@shared/services/api.service';
import { LocaleService } from '@shared/services/locale.service';
import { SnackService } from '@shared/services/snack.service';
import { ViewportService } from '@shared/services/viewport.service';
import { finalize } from 'rxjs';

@Component({
	selector: 'app-user-preferences',
	templateUrl: './user-preferences.component.html',
	styleUrls: ['./user-preferences.component.scss'],
})
export class UserPreferencesComponent implements OnInit {
	ALL = this.locale.translations['user']['wa-alerts']['n755'];
	carList = [
		{ id: '0', name: this.ALL },
		{ id: '2', name: this.locale.translations['user']['wa-alerts']['n756'] },
		{ id: '34', name: this.locale.translations['user']['wa-alerts']['n757'] },
		{ id: '20', name: this.locale.translations['user']['wa-alerts']['n758'] },
		{ id: '25', name: this.locale.translations['user']['wa-alerts']['n759'] },
		{ id: '13', name: this.locale.translations['user']['wa-alerts']['n760'] },
		{ id: '54', name: this.locale.translations['user']['wa-alerts']['n761'] },
		{ id: '17', name: this.locale.translations['user']['wa-alerts']['n762'] },
		{ id: '15', name: this.locale.translations['user']['wa-alerts']['n763'] },
		{ id: '42', name: this.locale.translations['user']['wa-alerts']['n764'] },
		{ id: '4', name: this.locale.translations['user']['wa-alerts']['n765'] },
	];

	carListNoAll = this.carList.filter((c) => c.name !== this.ALL);
	yearList = ['2025, 2024, 2023', '2022, 2021, 2020', '2019, 2018, 2017', '2016, 2015, 2014', '2013, 2012, 2011', '2010 - 1990'];
	loading = false;
	constructor(
		public locale: LocaleService,
		public viewport: ViewportService,
		private fb: FormBuilder,
		private api: ApiService,
		private snack: SnackService
	) {}

	form = this.fb.group({
		make: new FormControl<string[]>([], { nonNullable: true, validators: [Validators.required] }),
		year: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
	});

	onSubmit() {
		this.form.markAllAsTouched();
		if (this.form.invalid || this.loading) return;

		const { make, year } = this.form.value as { make: string[]; year: string };

		const payload = {
			lang: this.locale.lang,
			make_id: make,
			year_selected: year,
			opt_in: true,
		};
		this.loading = true;
		this.api
			.saveAlerts(payload)
			.pipe(finalize(() => (this.loading = false)))
			.subscribe({
				next: (res: any) => {
					this.snack.open(res?.message || this.locale.translations['user']['wa-alerts']['n766']);
				},
				error: (err: any) => {
					const errorMsg = err?.error.message || err?.message || this.locale.translations['user']['wa-alerts']['n767'];

					this.snack.open(errorMsg);
				}
			});
	}


	ngOnInit(): void {
		this.getUserPreferences();
	}

	getUserPreferences() {
		this.api.getAlerts().subscribe((res: any) => {
			this.form.patchValue({
				make: res?.make_id,
				year: res?.year_selected,
			});
		});
	}

	get selectedCarsTrigger(): string {
		const ids: string[] = (this.form.value?.make as string[]) || [];
		if (ids.includes('0')) return this.ALL;
		const names = ids.map((id) => this.carList.find((c) => c.id === id)?.name || id);
		return names.join(', ');
	}

	onAllToggled(event: MatOptionSelectionChange) {
		if (event.isUserInput === false) return; // ignore programmatic changes

		if (event.source.selected) {
			// Select only '0' to represent All Models
			this.form.controls.make.setValue(['0']);
		} else {
			// Clearing All clears everything
			this.form.controls.make.setValue([]);
		}
	}

	onSelectChange(event: MatSelectChange) {
		const rawValues: string[] = event.value || [];
		// If '0' (All) is selected alongside others, remove '0'
		if (rawValues.includes('0') && rawValues.length > 1) {
			const filtered = rawValues.filter((v) => v !== '0');
			this.form.controls.make.setValue(filtered);
			return;
		}

		// Otherwise, keep as-is
		this.form.controls.make.setValue(rawValues);
	}
}
